import React, { useState, useEffect } from 'react';
import {
  Box, Button, Card, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Typography, Chip, IconButton
} from '@mui/material';
import { Add, Edit, Delete } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { rewardsAPI } from '../../services/api';

export default function RewardList() {
  const navigate = useNavigate();
  const [rewards, setRewards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRewards();
  }, []);

  const loadRewards = async () => {
    try {
      const response = await rewardsAPI.getMyRewards();
      setRewards(response.data.data);
    } catch (error) {
      console.error('Error loading rewards:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this reward?')) return;
    try {
      await rewardsAPI.deleteReward(id);
      loadRewards();
    } catch (error) {
      console.error('Error deleting reward:', error);
    }
  };

  if (loading) return <Typography>Loading...</Typography>;

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4">My Rewards</Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => navigate('/rewards/new')}
        >
          Create Reward
        </Button>
      </Box>

      <TableContainer component={Card}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Points Cost</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Valid Until</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rewards.map((reward) => (
              <TableRow key={reward._id}>
                <TableCell>{reward.title}</TableCell>
                <TableCell>{reward.pointsCost}</TableCell>
                <TableCell>
                  <Chip label={reward.category} size="small" />
                </TableCell>
                <TableCell>
                  <Chip
                    label={reward.status}
                    size="small"
                    color={reward.status === 'active' ? 'success' : 'default'}
                  />
                </TableCell>
                <TableCell>
                  {new Date(reward.validUntil).toLocaleDateString()}
                </TableCell>
                <TableCell align="center">
                  <IconButton
                    size="small"
                    onClick={() => navigate(`/rewards/${reward._id}/edit`)}
                  >
                    <Edit />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => handleDelete(reward._id)}
                  >
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {rewards.length === 0 && (
        <Card sx={{ mt: 2, p: 3, textAlign: 'center' }}>
          <Typography color="text.secondary">
            No rewards yet. Create your first reward to get started.
          </Typography>
        </Card>
      )}
    </Box>
  );
}
